// extracted by mini-css-extract-plugin
export default {"bookWrap":"adminBookDrafts_bookWrap__ocP8g","bookItem":"adminBookDrafts_bookItem__T2Vrf","bookCover":"adminBookDrafts_bookCover__FzXJW","bookInfo":"adminBookDrafts_bookInfo__TPx1L"};